import { Pipe, PipeTransform } from '@angular/core';
import { MetadataService } from '../../../../../services/metadata.service';
import { map, Observable } from 'rxjs';
import { MetadataColumnFormat, MetadataDataType } from '../../../../../models/metadata';

@Pipe({
  name: 'columnDataFormats',
  standalone: true
})
export class ColumnDataFormatsPipe implements PipeTransform {
  constructor(private metadataService: MetadataService) {}

  transform(columnDataType: MetadataDataType): Observable<MetadataColumnFormat[]> {
    return this.metadataService
      .getMetadata()
      .pipe(map(metadata => metadata.columnFormats.filter(format => format.columnDataType === columnDataType)));
  }
}
